<template>
    <div class="alert" :class="[tipo]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props:['tipo']
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/shared/alert.vue